
import startApp from "../../entry";
// const homePage = () => import("@/pages/homePage.vue");
import homePage from "./homePage.vue";

startApp(homePage);
